import "./App.css";
// import { useEffect } from "react";
import AllRoutes from "./Routes";
import { Provider } from "react-redux";
import store from "./reduxStore";
import { theme } from "./Theme/Theme";
import { ThemeProvider } from "@mui/system";
import { setupInterceptors } from "./api/apiClient";
import keycloak from "./keycloak";
//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";

//core
import "primereact/resources/primereact.min.css";
// import { licenseServices } from "./Components/License/services/license.bank.service";

//setup axios interceptors
setupInterceptors(store, keycloak);

// const Layout = AuthenticatedLayout;
function App() {
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     // This code will execute when the user is about to refresh the page to invalidate the current token
  //     event.preventDefault();

  //     const state = store.getState();

  //     fetch(
  //       `https://3.21.57.79:8099/api/bank/license/invalidate/${keycloak.tokenParsed["license-key"]}`,
  //       {
  //         method: "POST",
  //         keepalive: true,
  //         headers: {
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ token: state.licenseValidity.token }),
  //       }
  //     );

  //     // licenseServices
  //     //   .inValidateLicense(keycloak.tokenParsed["license-key"], {
  //     //     token: state.licenseValidity.token,
  //     //   })
  //     //   .then(() => {
  //     //     console.log("Cleared Token");
  //     //   })
  //     //   .catch((e) => alert(e.message));

  //     // return (event.returnValue = "User is about to refresh the page");
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AllRoutes />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
